<script setup lang="ts">
  const props = withDefaults(
    defineProps<{
      statusCode?: number
      /** When true, clear Nuxt error state before navigating (used by error.vue). */
      clearOnNavigate?: boolean
    }>(),
    {
      statusCode: 404,
      clearOnNavigate: false,
    },
  )

  const localePath = useLocalePath()

  const resultStatus = computed(() => {
    const code = props.statusCode || 500
    if (code === 404 || code === 403 || code === 500 || code === 418) return String(code) as '404' | '403' | '500' | '418'
    if (code >= 500) return 'error' as const
    return 'error' as const
  })

  const title = computed(() => (props.statusCode === 404 ? '页面不存在' : '出错了'))
  const description = computed(() =>
    props.statusCode === 404
      ? '你访问的管理页面不存在，或已被移除。'
      : '管理端加载时发生错误，请稍后重试。',
  )

  function goDashboard() {
    const target = localePath('/admin/dashboard')
    if (props.clearOnNavigate) {
      clearError({ redirect: target })
      return
    }
    navigateTo(target)
  }

  function goBack() {
    if (props.clearOnNavigate) clearError()
    if (import.meta.client && window.history.length > 1) {
      window.history.back()
      return
    }
    navigateTo(localePath('/admin/dashboard'))
  }
</script>

<template>
  <div class="admin-error">
    <n-result :status="resultStatus" :title="title" :description="description">
      <template #footer>
        <div class="admin-error__actions">
          <n-button type="primary" @click="goDashboard">返回工作台</n-button>
          <n-button @click="goBack">返回上一页</n-button>
        </div>
      </template>
    </n-result>
  </div>
</template>

<style lang="scss" scoped>
  .admin-error {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    min-height: 360px;
    padding: 24px;
  }

  .admin-error__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: center;
  }
</style>
